import { connect } from "react-redux";
import ConfiguratorActions from "../../../buyer_portal/actions/configuratorActions";
import UnitAwarePage from "../../components/roomBook/UnitAwarePage";
import {
  CATALOG_RESOURCE,
  getResource,
  LINE_ITEM_RESOURCE,
  UNIT_RESOURCE
} from "../../actions/actionLocator";
import { SectionCompletedResource } from "../../actions/localTableResource";
import { isReady } from "../../selectors/unit";
import { getProjectBranding } from "../../selectors";

const mapStateToProps = (state, props) => {
  return {
    i18n: state.i18n,
    isReady: isReady(state),
    branding: getProjectBranding(state, props)
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { id, projectId } = props.params;

  const UnitsResource = getResource(UNIT_RESOURCE);
  const CatalogsResource = getResource(CATALOG_RESOURCE);
  const LineItemResource = getResource(LINE_ITEM_RESOURCE);

  return {
    loadUnit: (deep, glencoeURL) => {
      return Promise.all([
        new UnitsResource(dispatch, projectId).get(id, deep),
        new ConfiguratorActions(dispatch, glencoeURL).getMapping(),
        new CatalogsResource(dispatch, id).get(),
        new LineItemResource(dispatch, id).get(),
        new SectionCompletedResource(dispatch).get()
      ]);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitAwarePage);
